import { useEffect, useState } from "react"
import Select from 'react-select'
import { useDispatch, useSelector } from "react-redux"
import { useAuthState } from "../../Helper/Context"
import { useTranslation } from "react-i18next"

export const DesignationCommanDDL = (props) => {
    const { DesignationNameID, setDesignationNameID, Flag, data, IsPost, Language, StarMark } = props

    const { t } = useTranslation()

    const dispatch = useDispatch()
    const userDetails = useAuthState();
    const { UserID, token } = userDetails

    useEffect(() => {
        const data = {
            UserID: UserID,
            lanaguage: Language.Label,
            token: token
        }
        // { Language.Label != '' && dispatch(DesignationNameDDLAPI({ data })) }
    }, [IsPost, Language.Label])

    // const { DDLData } = useSelector(state => state.DesignationNameDDLData)

    // useEffect(() => {
    //     handleDDL()
    // }, [DDLData])

    // const handleDDL = () => {
    //     if (DDLData && DDLData.table && DDLData.table.length > 0) {
    //         let list = DDLData.table.map((item, index) => ({
    //             value: item.m_DesignationID,
    //             label: item.designationName,
    //         }))

    //         setDesignationNameID({
    //             DDL: list,
    //             ID: Flag == 'Update' ? data?.m_DesignationID : 0,
    //             Label: Flag == 'Update' ? data?.designationName : "Select...",           
    //         })
    //     }
    //     else {
    //         setDesignationNameID({
    //             DDL: [],
    //             ID: 0,
    //             Label: "Select...",
    //         })
    //     }
    // }
    return (
        <div className="form-group">
            <label className="d-block fs-8 pb-2" htmlFor="Designation">{t('EncroachmentDashboard.DesignationName')}</label>
            <Select
                id='WardNameID'
                isClearable={false}
                // isRtl={isRtl}
                isSearchable
                maxMenuHeight={130}
                value={{ value: DesignationNameID.ID, label: DesignationNameID.Label }}
                onChange={(e) => {
                    e ?
                        setDesignationNameID({ ...DesignationNameID, ID: e.value, Label: e.label })
                        :
                        setDesignationNameID({ ...DesignationNameID, ID: 0, Label: "Select..." })

                }}
                options={DesignationNameID.DDL}
            />
        </div>
    )
}